import { defineComponent as _defineComponent } from 'vue'
import { AnalyticsPromoAttrs } from 'JS/utilities/analytics';
import { FeaturedCategoriesWidgetItemData } from 'JS/dxp/types/widgets';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturedCategoriesWidgetCard',
  props: {
    category: null,
    clickDataAttributes: null
  },
  setup(__props: any) {

const props = __props as {
	category: FeaturedCategoriesWidgetItemData;
	clickDataAttributes: AnalyticsPromoAttrs;
}




return { __sfc: true,props }
}

})